import { ERecouvrement } from "./enum/recouvrement";

export class IBMRVitesseCourant {
    VInferieur005: ERecouvrement = ERecouvrement.Absent; 
    VEntre005Et02: ERecouvrement = ERecouvrement.Absent; 
    VEntre02Et05: ERecouvrement = ERecouvrement.Absent; 
    VEntre05Et1: ERecouvrement = ERecouvrement.Absent; 
    VSuperieur1: ERecouvrement = ERecouvrement.Absent; 

    static mapFromJSON(json): IBMRVitesseCourant {
        const vc = new IBMRVitesseCourant();

        vc.VInferieur005 = json.vInferieur005;
        vc.VEntre005Et02 = json.vEntre005Et02;
        vc.VEntre02Et05 = json.vEntre02Et05;
        vc.VEntre05Et1 = json.vEntre05Et1;
        vc.VSuperieur1 = json.vSuperieur1;

        return vc;
    }
}